import { render, staticRenderFns } from "./DistillationColumnB.vue?vue&type=template&id=27dc45dd&scoped=true&"
import script from "./DistillationColumnB.vue?vue&type=script&lang=js&"
export * from "./DistillationColumnB.vue?vue&type=script&lang=js&"
import style0 from "./DistillationColumnB.vue?vue&type=style&index=0&id=27dc45dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dc45dd",
  null
  
)

export default component.exports